// src/components/MoraLogo.jsx
import React from 'react';

export default function MoraLogo({ collapsed = false }) {
  return (
    <div className="flex items-center gap-3">
      <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center flex-shrink-0">
        <span className="text-white font-bold text-xl leading-none">M</span>
      </div>
      {!collapsed && (
        <div>
          <h1 className="text-lg font-bold text-slate-800 dark:text-slate-100 tracking-tight leading-tight">
            FlipperPro
          </h1>
          <p className="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-tight">
            Real Estate Platform
          </p>
        </div>
      )}
    </div>
  );
}
